import { PropTypes } from "react-recollect";

function RenderFieldColumn({
  leftContent,
  borderT,
  borderB,
  children,
  highlight,
  rightExtraClasses = "",
  leftWidthClass = "w-60",
  leftPaddingClass = "pt-4 pb-2",
}) {
  if (leftContent === false)
    return (
      <div className={`flex-1 px-2 py-1 ${rightExtraClasses}`}>{children}</div>
    );
  return (
    <div className="flex">
      <div
        className={`flex-none ${leftWidthClass} ${leftPaddingClass} bg-gradient-to-r ${highlight ? "from-yellow-200/50 to-slate-300 border-yellow-400" : "from-transparent to-slate-100 border-slate-300"} border-r text-right${
          borderT ? " border-t border-t-slate-300" : ""
        }${borderB ? " border-b border-b-slate-300" : ""}`}
      >
        <div className="px-2">{leftContent}</div>
      </div>
      <div
        className={`flex-1 px-2 py-1 ${rightExtraClasses} ${highlight ? "bg-yellow-200/25" : ""}`}
      >
        {children}
      </div>
    </div>
  );
}

RenderFieldColumn.propTypes = {
  children: PropTypes.node,
  leftContent: PropTypes.node,
  rightExtraClasses: PropTypes.string,
  leftWidthClass: PropTypes.string,
  leftPaddingClass: PropTypes.string,
  borderB: PropTypes.bool,
  borderT: PropTypes.bool,
};
export default RenderFieldColumn;
